import { ReactComponent as svg } from '../../assets/icons/profile.svg';
import Icon from './Icon';

const ProfileIcon = () => (<Icon Svg={svg} />);

export default ProfileIcon;
